module.exports = "\n.view-title {\n  margin-bottom: 20px;\n}\n\n.no-wishlist {\n  font-family: Open Sans, Helvetica Neue, sans-serif !important;\n  font-weight: 400;\n  font-size: 2rem;\n  color: #949799;\n  margin: 40px 0;\n}\n\n@media (min-width: 765px) {\n\n  .no-wishlist {\n    font-size: 2.5rem;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/wishlist.component.css
// module id = ./src/app/components/wishlist.component.css
// module chunks = main